import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(mkgeu)/mkg-add-on/[id]/[titel]/MkgAddOn.module.scss");
